<template>
    <span id="confirmcontainer">
        <sweet-modal :icon="icon" :ref="uuid" overlay-theme="white" :title="title">
            <div class="slot-content">
                <div v-html="message" class="alertmessage"></div>
            </div>
            <div class="panel-footer" slot="button" style="background-color: white; border-top: none; text-align: right;">
                <button v-if="Ncallback" class="btn btn-danger" style="margin-right: 30px;" @click.prevent="close('n')">{{NtxtBtn}}</button>
                <button v-if="Ycallback" class="btn btn-primary-default" @click.prevent="close('y')">{{YtxtBtn}}</button>
            </div>
        </sweet-modal>
    </span>
</template>
<script>

import { SweetModal } from "sweet-modal-vue";
import { toggleVisibility } from './toggleVisibilityMixin.js';

export default {
    props: {
        message: String,
        Ycallback: Function,
        Ncallback: Function,
        YtxtBtn: {
            type: String,
            default(){
                return this.$Jed.firstUpperTranslate('yes')
            }
        },
        NtxtBtn: {
            type: String,
            default(){
                return this.$Jed.firstUpperTranslate('no')
            }
        },
        title: {
            type: String,
            default(){
                return this.$Jed.firstUpperTranslate('warning')
            }
        },
        icon: {
            type: String,
            default: 'info'
        }
    },
    components: {
        SweetModal
    },
    mixins: [toggleVisibility],
    mounted: function(){
        var vm = this;
        this.$nextTick(function(){
            this.$emit("API", { open: this.$refs[this.uuid].open, close: this.$refs[this.uuid].close })
        });
    },
    data: function() {
        return {}
    }
}
</script>

<style>
/* .sweet-modal-overlay {
    z-index: 9999
} */
div.theme-light div.sweet-title {
    color: white; 
    background-color: #3c8dbc;
}

#confirmcontainer .sweet-content{
    padding: 32px 64px !important
}

#confirmcontainer .sweet-title{
    color: #3c8dbc !important;
    background-color: white !important;
}
</style>

<style scoped>
.sweet-modal-overlay {
    z-index: 9999999
}

#confirmcontainer .alertmessage {
    font-size: 16px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/dynamic/modalWrapper/Confirm.vue?568ba4cc